function normalize(str) {
  if (str) {
    let string = str.replace(/\W/g, '-').replace(/-+/g, '-').toLowerCase();
    return string;
  }
}

function normalizePreserveCase(str) {
  if (str) {
    let string = str.replace(/\W/g, '-').replace(/-+/g, '-');
    return string;
  }
}

export default normalize;
export { normalizePreserveCase };
